import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { RootWorkspaces, RootClientCreate } from 'features/root';
import Logout from 'startup/protected/Logout';
import * as paths from 'paths';

const Routes: FC = () => (
  <Switch>
    <Route exact path={paths.clientCreate} component={RootClientCreate} />
    <Route exact path={paths.workspaces} component={RootWorkspaces} />
    <Route exact path={paths.logout} component={Logout} />
    <Route render={() => <Redirect to={`${paths.workspaces}${location.search}`} />} />
  </Switch>
);

export default Routes;
